module.exports = __webpack_public_path__ + "static/media/Dream_SE_EN.73e71b6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dream_SE_EN.png
// module id = 552
// module chunks = 0